// Wave 2 · P0 (Feb-2026) — Curriculum Deep-Dive ↔ Pillar Bidirectional Map.
//
// Maps every "Curriculum · <X>" DB category (used by the 5 curriculum-guides
// articles) to its parent curriculum pillar page, plus display metadata. Used
// on three surfaces:
//
//   1. /blog/category/curriculum-guides  — per-curriculum landing chips row,
//      article groupings, and pillar deep-links.
//   2. /post/<slug>                      — inline "Explore the <Curriculum>
//      pillar" CTA card on every curriculum-category article.
//   3. Curriculum pillar pages           — "Deep-dive articles" block linking
//      to the specific curriculum-guides article + full hub.
//
// Kept in one map so the three surfaces never drift.

export const CURRICULUM_GUIDE_MAP = {
    "Curriculum · GCSE UK": {
        curriculum: "GCSE",
        region: "United Kingdom",
        flag: "🇬🇧",
        pillarPath: "/gcse-online-tuition-uk",
        pillarLabel: "GCSE Online Tuition (UK)",
        ctaLabel: "Explore the GCSE UK curriculum pillar",
    },
    "Curriculum · Australian Curriculum (ACARA)": {
        curriculum: "ACARA (F–10)",
        region: "Australia",
        flag: "🇦🇺",
        pillarPath: "/australian-curriculum-online-tuition-acara",
        pillarLabel: "Australian Curriculum (ACARA) Online Tuition",
        ctaLabel: "Explore the ACARA curriculum pillar",
    },
    "Curriculum · VCE Victoria": {
        curriculum: "VCE",
        region: "Victoria, Australia",
        flag: "🇦🇺",
        pillarPath: "/vce-online-tuition-victoria",
        pillarLabel: "VCE Online Tuition (Victoria)",
        ctaLabel: "Explore the VCE Victoria curriculum pillar",
    },
    "Curriculum · HSC NSW": {
        curriculum: "HSC",
        region: "NSW, Australia",
        flag: "🇦🇺",
        pillarPath: "/hsc-online-tuition-nsw",
        pillarLabel: "HSC Online Tuition (NSW)",
        ctaLabel: "Explore the HSC NSW curriculum pillar",
    },
    "Curriculum · Leaving Cert Ireland": {
        curriculum: "Leaving Certificate",
        region: "Ireland",
        flag: "🇮🇪",
        pillarPath: "/leaving-cert-online-tuition-ireland",
        pillarLabel: "Leaving Cert Online Tuition (Ireland)",
        ctaLabel: "Explore the Leaving Cert Ireland curriculum pillar",
    },
};

// Ordered category list — used by BlogCategory.jsx to render the per-curriculum
// chips in a stable, editorial order (largest / most-searched first).
export const CURRICULUM_GUIDE_ORDER = [
    "Curriculum · GCSE UK",
    "Curriculum · Australian Curriculum (ACARA)",
    "Curriculum · VCE Victoria",
    "Curriculum · HSC NSW",
    "Curriculum · Leaving Cert Ireland",
];

// Reverse map — pillar path → { category, meta } — so the curriculum-pillar
// pages can look up their matching deep-dive category with one line.
export const PILLAR_PATH_TO_CATEGORY = Object.fromEntries(
    Object.entries(CURRICULUM_GUIDE_MAP).map(([cat, meta]) => [meta.pillarPath, { category: cat, ...meta }]),
);

// Convenience helper — returns the pillar meta for a given DB category string,
// or `null` if the category isn't one of the five curriculum-guides categories.
export function getPillarForCategory(category) {
    return CURRICULUM_GUIDE_MAP[category] || null;
}
